import { request } from "../../../services/api"
import type { BaseApiResponse } from "../../../types/api.ts"
import type {
  Attachment,
  AttachmentFilterOptions
} from "../types/attachment.types.ts"
import type {
  AttachmentId,
  AttachmentListData,
  AttachmentListParams,
  AttachmentMoveData,
  AttachmentRenameData,
  AttachmentUploadRequestData
} from "./services.types.ts"

const BASE_URL = `/project-management/attachments`

const PATHS = {
  list: `${BASE_URL}/`,
  filterOptions: `${BASE_URL}/filter_options/`,
  upload: `${BASE_URL}/upload/`,
  rename: (id: AttachmentId) => `${BASE_URL}/${id}/`,
  delete: (id: AttachmentId) => `${BASE_URL}/${id}/`
}

// GET /project-management/attachments/
export const getAttachments = async (params?: AttachmentListParams) => {
  return request.api.get<AttachmentListData, BaseApiResponse<unknown>>(
    PATHS.list,
    params
  )
}

// GET /project-management/attachments/filter_options/
export const getAttachmentsFilterOptions = async () => {
  return request.api.get<AttachmentFilterOptions, BaseApiResponse<unknown>>(
    PATHS.filterOptions
  )
}

// POST /project-management/attachments/upload/
export const uploadAttachment = async (
  data: AttachmentUploadRequestData,
  signal?: AbortSignal
) => {
  return request.api.post<
    BaseApiResponse<Attachment>,
    BaseApiResponse<unknown>
  >(PATHS.upload, data, {
    headers: { "Content-Type": "multipart/form-data" },
    signal
  })
}

// PATCH /project-management/attachments/{id}/
export const renameAttachment = async (
  id: AttachmentId,
  data: AttachmentRenameData
) => {
  return request.api.patch<
    BaseApiResponse<Attachment>,
    BaseApiResponse<unknown>
  >(PATHS.rename(id), data)
}

// PATCH /project-management/attachments/{id}/ — folder placement only
export const moveAttachment = async (
  id: AttachmentId,
  data: AttachmentMoveData
) => {
  return request.api.patch<
    BaseApiResponse<Attachment>,
    BaseApiResponse<unknown>
  >(PATHS.rename(id), data)
}

// DELETE /project-management/attachments/{id}/
export const deleteAttachment = async (id: AttachmentId) => {
  return request.api.delete<BaseApiResponse<null>, BaseApiResponse<unknown>>(
    PATHS.delete(id)
  )
}
